export const CALL_INTEL_BASE_URL = '/analytics/call-intelligence';
export const CALL_RECORDING_SETTINGS = '/phone/call-recording';
export const CI_FEATURE_VIDEO_URL = 'https://fast.wistia.net/embed/iframe/00q24rsmga?videoFoam=true';
export const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
export const TRAINING_CAMP_URL = 'https://trainingcamp.weavehelp.com/new-weave-admin-call-intelligence';
